interface DateProps {
  className: string
  text: string
}

export const DateText = ({ className, text }: DateProps) => {
  return <span className={`block ${className}`}>{text}</span>
}
